import { render, staticRenderFns } from "./ProjectsManager.vue?vue&type=template&id=9b93de44&scoped=true"
import script from "./projectsManager.ts?vue&type=script&lang=ts&external"
export * from "./projectsManager.ts?vue&type=script&lang=ts&external"
import style0 from "./ProjectsManager.vue?vue&type=style&index=0&id=9b93de44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b93de44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b93de44')) {
      api.createRecord('9b93de44', component.options)
    } else {
      api.reload('9b93de44', component.options)
    }
    module.hot.accept("./ProjectsManager.vue?vue&type=template&id=9b93de44&scoped=true", function () {
      api.rerender('9b93de44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/manager/projects/ProjectsManager.vue"
export default component.exports